import { render } from "./CmsPageDetails.vue?vue&type=template&id=9991ee3a&lang=html"
import script from "./CmsPageDetails.vue?vue&type=script&lang=js"
export * from "./CmsPageDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__